import { useQuery } from '@tanstack/react-query';

import { getOffering } from '@arrived/api_v2';
import { Offering, OfferingIdOrShortName } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { offeringKeyFn } from './offerings.keys';

export function useOfferingQuery(
  offeringId?: OfferingIdOrShortName,
  options?: UseQueryOptions<Offering>
): UseQueryResult<Offering> {
  return useQuery(offeringKeyFn(offeringId!), async () => getOffering(offeringId!), {
    ...options,
    enabled: (options?.enabled ?? true) && offeringId != null,
    staleTime: options?.staleTime ?? 10_000,
    // TODO: UPDATE! The problem described here is fixed with react-query v4
    //  Unfortunately, we can't take this data and insert it into the query cache for the GET /offerings call. The
    //  specific reason is that onSettled and onSuccess both get invoked when the cached value under a key is updated.
    //  Since useOfferingsQuery also inserts data in the query cache for each offering, this means that we get an
    //  infinite cycle of each onSuccess updating the other queries cached value.
  });
}
